import { render, staticRenderFns } from "./ProducerDashboard.vue?vue&type=template&id=adfbbaf8"
import script from "./ProducerDashboard.vue?vue&type=script&lang=js"
export * from "./ProducerDashboard.vue?vue&type=script&lang=js"
import style0 from "./ProducerDashboard.vue?vue&type=style&index=0&id=adfbbaf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports